import { Injectable } from '@angular/core';
import { ApiService} from '../../../../core/service/api.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class ProvidersService {

  constructor(private api: ApiService) { }

    getServiceProviders(): Observable<any> {
      return this.api.get('vna/service-provider');
    }

    postServiceProvider(provider: Object): Observable<any> {
      return this.api.post('vna/service-provider', provider);
    }
    removeServiceProvider(pk: any): Observable<any> {
      return this.api.remove('vna/service-provider', pk);
    }
    putServiceProvider(pk: number, provider: any): Observable<any> {
        return this.api.put('vna/service-provider', pk, provider);
    }

    getCallerIdsConfig(pkProvider: number): Observable<any> {
        return this.api.get('vna/service-provider/' + pkProvider + '/caller-id-configs');
    }

    postCallerIdConfig(pkProvider: number, data: Object): Observable<any> {
        return this.api.post('vna/service-provider/' + pkProvider + '/caller-id-config', data);
    }

    putCallerIdConfig(pk: number, data: Object): Observable<any> {
        return this.api.put('vna/service-provider/caller-id-config', pk, data);
    }

    patchCallerIdConfig(pk: number, data: Object): Observable<any> {
        return this.api.patch('vna/service-provider/caller-id-config', pk, data);
    }

    deleteCallerIdConfig(pk: number): Observable<any> {
        return this.api.remove('vna/service-provider/caller-id-config', pk);
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/providers/services/providers.service.ts